import React from 'react'
import {useGetAdaptiveStyle, SecretLetter, type SecretLetterProps} from 'uikit'
import {isMobileUserAgent} from 'services/app'

type Props = Omit<SecretLetterProps, 'size'>

export const SecretLetterWrapper: React.FC<Props> = (props) => {
  const isMobile = isMobileUserAgent()
  const {heightSize, widthSize} = useGetAdaptiveStyle([])
  const size = isMobile ? widthSize : heightSize

  return (
    <SecretLetter {...props} size={size} />
  )
}
